import React from "react";
import { connect } from "react-redux";
import TextTruncate from "react-text-truncate";
import { Card, Button } from "tabler-react";
import { LoadingError } from "../../../../../component";
import "./style.css";

import { mapActions } from "../../../../../store/actions";

const FilterResults = (props) => {
  const { data, filterDataError, minRecord, maxRecord } = props;

  const setZoom = (obj, props) => {
    const position = obj.position;
    var lat = position[0];
    var lng = position[1];
    props.setZoomLevel([lat, lng]);
  };
  const clearFilters = (e) => {
    props.clearFilters();
  };
  const ClearAllFiltersBtn = (
    <div style={{ margin: "0px 20px" }}>
      <Card.Footer>
        <Card.Options>
          <Button color="primary" block size="sm" onClick={clearFilters}>
            Clear All Filters
          </Button>
        </Card.Options>
      </Card.Footer>
    </div>
  );
  const filterResultsHeader = (
    <>
      {ClearAllFiltersBtn}
      <Card.Footer>
        {minRecord} out of {maxRecord}
      </Card.Footer>
    </>
  );
  const notFound = (
    <>
      {ClearAllFiltersBtn}
      <Card.Footer>No record found</Card.Footer>
    </>
  );
  return (
    <div id="mapFiltersResults" className="incidents">
      {filterDataError !== null ? (
        <LoadingError errorMsg={filterDataError} />
      ) : maxRecord === 0 ? (
        notFound
      ) : (
        filterResultsHeader
      )}
      {data &&
        data?.map((obj, i) => {
          return (
            // return(<div className="incident" key={i}>{obj.detail}</div>)
            <div
              className="incident zoomToMarker"
              key={i}
              id={i}
              onClick={() => setZoom(obj, props)}
            >
              <Button
                // className="btn-link card-footer zoomToMarker"
                className="btn-link card-footer"
                data-longitude={obj.position[0]}
                data-latitude={obj.position[1]}
              >
                {"Date: " + obj.date}
              </Button>
              <TextTruncate
                line={4}
                element="p"
                truncateText="…"
                text={obj.detail}
              />
            </div>
          );
        })}
      ;
    </div>
  );
};

function mapStateToProps(state) {
  const {
    filterDataError,
    mapLoading,
    recordCount,
    showFilters,
    sidebarOpen,
  } = state.map;
  return {
    filterDataError,
    mapLoading,
    recordCount,
    showFilters,
    sidebarOpen,
  };
}
const mapDispatchToProps = {
  openFilterSidebar: mapActions.openFilterSidebar,
  setZoomLevel: mapActions.setZoomLevel,
  loadMapData: mapActions.loadMapData,
  clearMapFilters: mapActions.clearMapFilters,
};
export default connect(mapStateToProps, mapDispatchToProps)(FilterResults);
